import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import VantagensPage from "./components/VantagensPage";
import CadastroPage from "./components/CadastroPage";
import PagamentoPage from "./components/PagamentoPage";
import PagamentoRetornoPage from "./components/PagamentoRetornoPage";
import LoginPage from "./components/LoginPage";
import AdminPage from "./components/AdminPage";
import EditUserPage from "./components/EditUserPage";
// Digital Library Components
import EditorDashboard from "./components/EditorDashboard";
import DigitalCatalog from "./components/DigitalCatalog";
import SubscriberLogin from "./components/SubscriberLogin";
import TrialModePage from "./components/TrialModePage";
import { Toaster } from "./components/ui/sonner";
import BookAccessGate from "./components/BookAccessGate";
import ResetPasswordPage from "./components/ResetPasswordPage";
import TermsPage from "./components/TermsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Landing Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/vantagens" element={<VantagensPage />} />
          <Route path="/cadastro" element={<CadastroPage />} />
          <Route path="/pagamento" element={<PagamentoPage />} />
          <Route path="/pagamento/sucesso" element={<PagamentoRetornoPage tipo="sucesso" />} />
          <Route path="/pagamento/pendente" element={<PagamentoRetornoPage tipo="pendente" />} />
          <Route path="/pagamento/falha" element={<PagamentoRetornoPage tipo="falha" />} />
          
          {/* Auth & Admin */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
          <Route path="/termos-de-uso" element={<TermsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/editar-usuario/:userId" element={<EditUserPage />} />
          
          {/* Editor/Publisher Dashboard */}
          <Route path="/editor/dashboard" element={<EditorDashboard />} />
          
          {/* Digital Catalog & Reader */}
          <Route path="/catalogo/:editorId" element={<DigitalCatalog />} />
          <Route path="/catalogo/:editorId/login" element={<SubscriberLogin />} />
          <Route path="/catalogo/:editorId/livro/:bookId" element={<BookAccessGate />} />
          
          <Route path="/:editorId" element={<DigitalCatalog />} />
          <Route path="/:editorId/modo-teste" element={<TrialModePage />} />
          <Route path="/:editorId/login" element={<SubscriberLogin />} />
          <Route path="/:editorId/livro/:bookId" element={<BookAccessGate />} />
          <Route path="/leitor/login" element={<SubscriberLogin />} />

          {/* Legacy routes redirect */}
          <Route path="/biblioteca-digital/:editorId/catalogo" element={<DigitalCatalog />} />
          <Route path="/biblioteca-digital/:editorId/login" element={<SubscriberLogin />} />
          <Route path="/biblioteca-digital/:editorId/livro/:bookId" element={<BookAccessGate />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
